"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsControlsColorSpecification_1 = __importDefault(require("../typeAssertions/valueIsControlsColorSpecification"));
const getControlsColorSpecificationByString_1 = __importDefault(require("./getControlsColorSpecificationByString"));
const formatControlPropertyBeforeModify = ({ value, controlToModify, propertyToModify, }) => {
    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        const colorSpecification = (0, getControlsColorSpecificationByString_1.default)(trimmedValue);
        if ((0, valueIsControlsColorSpecification_1.default)(colorSpecification)) {
            return colorSpecification;
        }
        if (/^font:custom:[0-9]+$/.test(trimmedValue)) {
            const [, , fontValue] = trimmedValue.split(':');
            const customFontValue = {
                type: 'custom',
                value: Number(fontValue),
            };
            return customFontValue;
        }
        if (trimmedValue === 'font:global') {
            const globalFontSize = {
                type: 'global',
            };
            return globalFontSize;
        }
        if (/^[0-9]+(\.[0-9]+)?:(px|%)$/.test(trimmedValue)) {
            const [numberValue, unit] = trimmedValue.split(':');
            if (unit === 'px') {
                const complexUnit = {
                    unit,
                    value: Number(numberValue),
                };
                return complexUnit;
            }
            if (unit === '%') {
                const complexUnit = {
                    unit,
                    value: Number(numberValue),
                };
                return complexUnit;
            }
        }
        if (/^[0-9]+(\.[0-9]+)?$/.test(trimmedValue)) {
            return Number(trimmedValue);
        }
        if ((controlToModify.tag === 'Picker' || controlToModify.tag === 'radio')
            && propertyToModify === 'items') {
            const items = [];
            if (!trimmedValue) {
                return items;
            }
            const newData = trimmedValue.split('|', 2);
            if (newData.length === 2) {
                items.push({
                    label: newData[0],
                    value: newData[1],
                });
            }
            return items;
        }
        if (trimmedValue === 'false') {
            return false;
        }
    }
    return value;
};
exports.default = formatControlPropertyBeforeModify;
